import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const areas = [
  {
    key: 'dental',
    icon: 'ri-tooth-line',
    image: 'https://readdy.ai/api/search-image?query=Professional%20medical%20dental%203D%20illustration%20of%20a%20single%20titanium%20dental%20implant%20with%20ceramic%20crown%20integrated%20into%20gum%20tissue%2C%20cross-section%20view%20showing%20bone%20fusion%2C%20clean%20white%20and%20warm%20beige%20clinical%20color%20scheme%2C%20high%20detail%20medical%203D%20rendering%20style%2C%20soft%20gradients%20background%2C%20no%20text%20no%20logos%20no%20labels&width=600&height=400&seq=overview-dental-v2&orientation=landscape',
    accentClass: 'bg-primary-500',
    bgClass: 'bg-primary-50',
    borderClass: 'border-primary-200/60',
    hoverClass: 'hover:border-primary-300/70',
    titleClass: 'text-primary-900',
    badgeClass: 'bg-primary-100 text-primary-700',
  },
  {
    key: 'surgery',
    icon: 'ri-heart-pulse-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20beautiful%20woman%20with%20refined%20facial%20features%2C%20natural%20flawless%20glowing%20skin%2C%20soft%20warm%20studio%20lighting%2C%20luxury%20beauty%20photography%2C%20graceful%20expression%2C%20premium%20aesthetic%20medicine%20result%2C%20sophisticated%20editorial%20portrait%2C%20cream%20and%20warm%20neutral%20background%2C%20subtle%20anti%20aging%20beauty%20look&width=600&height=400&seq=overview-surgery-v2&orientation=landscape',
    accentClass: 'bg-accent-500',
    bgClass: 'bg-accent-50',
    borderClass: 'border-accent-200/60',
    hoverClass: 'hover:border-accent-300/70',
    titleClass: 'text-accent-900',
    badgeClass: 'bg-accent-100 text-accent-700',
  },
  {
    key: 'hair',
    icon: 'ri-user-smile-line',
    image: 'https://readdy.ai/api/search-image?query=Handsome%20confident%20man%20with%20full%20thick%20natural%20looking%20dark%20hair%2C%20well%20groomed%20professional%20appearance%2C%20soft%20warm%20studio%20lighting%2C%20clean%20neutral%20background%2C%20natural%20dense%20hairline%20close%20up%2C%20premium%20grooming%20editorial%20portrait%2C%20sharp%20focus%2C%20ultra%20realistic&width=600&height=400&seq=overview-hair-v2&orientation=landscape',
    accentClass: 'bg-secondary-500',
    bgClass: 'bg-secondary-50',
    borderClass: 'border-secondary-200/60',
    hoverClass: 'hover:border-secondary-300/70',
    titleClass: 'text-secondary-900',
    badgeClass: 'bg-secondary-100 text-secondary-700',
  },
];

export default function TreatmentsOverview() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="text-[10px] md:text-xs tracking-[0.25em] uppercase text-foreground-400 font-label">
            {t('overview.tag')}
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight">
            {t('overview.heading')}
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500 font-body max-w-2xl mx-auto leading-relaxed">
            {t('overview.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {areas.map((area) => (
            <div
              key={area.key}
              className={`group relative rounded-2xl overflow-hidden border ${area.borderClass} ${area.bgClass} ${area.hoverClass} transition-all duration-500 hover:scale-[1.01] flex flex-col`}
            >
              <div className="relative h-44 sm:h-52 md:h-60 overflow-hidden">
                <img
                  src={area.image}
                  alt={t(`overview.${area.key}.title`)}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] tracking-[0.15em] uppercase font-label font-semibold ${area.badgeClass}`}>
                    <i className={`${area.icon} text-xs`}></i>
                    {t(`overview.${area.key}.title`)}
                  </span>
                </div>
              </div>

              <div className="p-5 md:p-6 flex flex-col flex-1">
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed font-body">
                  {t(`overview.${area.key}.desc`)}
                </p>

                <div className="mt-4 md:mt-5 flex-1">
                  <p className="text-[11px] tracking-[0.15em] uppercase text-foreground-300 font-label mb-2.5">
                    {t('services.tag')}:
                  </p>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed font-body">
                    {t(`overview.${area.key}.treatments`)}
                  </p>
                </div>

                <Link
                  to={`/pricing#${area.key}`}
                  className={`mt-5 md:mt-6 inline-flex items-center justify-center gap-2 w-full py-2.5 md:py-3 rounded-full text-white text-[11px] md:text-xs tracking-[0.1em] uppercase font-label font-semibold hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap ${area.accentClass}`}
                >
                  {t('overview.cta')}
                  <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}